import(/* webpackMode: "eager" */ "/Users/mac_de_franck/Desktop/Code/Projects/DOUDOU/frontend/node_modules/next/dist/client/link.js");
